
/**
 * Formats alert titles/urls by adding given count and choosing singular/plurals and url path
 * @param {object} alert
 * @param {object} model
 * @return {Object} returns new alert with updated title and url
 */
function formatAlert (alert: any, model: any) {
  const formattedAlert = { ...alert }

  // Format title
  formattedAlert.title = model.title
    .replace(/{count}/g, alert.count)
    .replace(/\(.*\|.*\)/g, match => {
      const [singular, plural] = match.replace(/\(|\)/g, '').split('|')

      return alert.count > 1 ? plural : singular
    })

  // Format url
  if (model.url) {
    formattedAlert.url = model.url
      .replace(/{path}/g, alert.path)
  }

  return formattedAlert
}

export { formatAlert }
